<template>
  <div class="attachment-chip-container">
    <v-chip
      v-for="attachment in attachments"
      :key="attachment.id"
      class="attachment-chip ma-1"
      color="grey-lighten-4"
      variant="elevated"
      size="medium"
      density="comfortable"
    >
      <v-tooltip location="top">
        <template #activator="{ props }">
          <div v-bind="props" class="d-flex align-center">
            <v-icon size="small" color="primary" class="mr-2">
              {{ fileIcon(attachment.file_extension) }}
            </v-icon>
            <span class="text-truncate" style="max-width: 150px">{{
              attachment.file_name
            }}</span>
          </div>
        </template>
        <span>{{ attachment.file_name }}</span>
      </v-tooltip>

      <template #append>
        <div class="attachment-actions d-flex">
          <v-btn
            icon="mdi-eye"
            size="x-small"
            variant="text"
            color="primary"
            :href="attachment.file_dl"
            target="_blank"
            class="mx-1"
          ></v-btn>
          <v-btn
            icon="mdi-close"
            size="x-small"
            variant="text"
            color="error"
            class="mx-1"
            @click="deleteAttachment(attachment.id)"
          ></v-btn>
        </div>
      </template>
    </v-chip>
  </div>
</template>

<script>
import { useAttachmentsStoreRefactor } from "@/stores/attachmentsStoreRefactor";
import { useAlertStore } from "@/stores/alertStore";

export default {
  name: "AttachmentChip",
  props: ["attachments"],
  emits: ["refresh"],
  setup(props, { emit }) {
    const attachmentsStore = useAttachmentsStoreRefactor();
    const alertStore = useAlertStore();

    const deleteAttachment = async (attachmentId) => {
      if (confirm("Weet je zeker dat je dit bestand wilt verwijderen?")) {
        try {
          await attachmentsStore.delete(attachmentId);
          alertStore.success("Bestand succesvol verwijderd");
          // Emit an event so the parent component can refresh the attachments list
          emit("refresh");
        } catch (error) {
          console.error("Error deleting attachment:", error);
          alertStore.error(
            "Er is een probleem opgetreden bij het verwijderen van het bestand",
          );
        }
      }
    };

    const fileIcon = (extension) => {
      if (!extension) return "mdi-file-upload";

      const ext = String(extension).toLowerCase();
      if (ext.includes("pdf")) return "mdi-file-pdf-box";
      if (ext.includes("doc")) return "mdi-file-word";
      if (ext.includes("xls")) return "mdi-file-excel";
      if (ext.includes("ppt")) return "mdi-file-powerpoint";
      if (
        ext.includes("jpg") ||
        ext.includes("jpeg") ||
        ext.includes("png") ||
        ext.includes("gif")
      )
        return "mdi-file-image";
      if (
        ext.includes("zip") ||
        ext.includes("rar") ||
        ext.includes("tar") ||
        ext.includes("gz")
      )
        return "mdi-zip-box";
      return "mdi-file-document";
    };

    return {
      deleteAttachment,
      fileIcon,
    };
  },
};
</script>

<style scoped>
.attachment-chip-container {
  display: flex;
  flex-wrap: wrap;
  margin: -4px;
}

.attachment-chip {
  transition: all 0.2s ease;
}

.attachment-chip:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.attachment-actions {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.attachment-chip:hover .attachment-actions {
  opacity: 1;
}
</style>
